export const searchColumns = (ctx) => {
  return [
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      disabled: ctx.query?.businessCompanyNo == '',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      options: ctx.expenseTypeList,
    },
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategory || [],
    },
    {
      name: '应收账期',
      prop: 'accountPeriod',
      type: 'date',
      format: 'yyyy-MM',
    },
    {
      // 申请日期从
      name: '业务账期从',
      prop: 'periodDateFromStart',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务账期至',
      prop: 'periodDateUntilEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '客户名称',
      prop: 'customerNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.query.businessCompanyNo,
        departmentCode: ctx.query.businessDepartmentCode,
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
      },
      isMultiple: true,
      changeMethod: ctx.customerNoMethod,
    },
    {
      name: '费用生成日期从',
      prop: 'expenseGenerationDateStart	',
      type: 'startDaterangePicker',
    },
    {
      name: '费用生成日期至',
      prop: 'expenseGenerationDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'superviseContract',
      extraData: {
        contractStatus: '03',
        departmentCode: ctx.query.businessCompanyNo,
        companyCode: ctx.query.businessDepartmentCode,
        // contractType: '0',
        // isCS: 'S',
        // createDepartmentNo: ctx.query.settlementDepartmentNo,
      },
      // extraData: {
      //   contractCategory: 'sales',
      //   contractBusinessCompanyNo: ctx.query.businessCompanyNo,
      //   contractBusinessDepartment: ctx.query.businessDepartmentCode,
      //   contractDetailCategory: 'CG04', //制单类型过滤协议的
      // },
      isMultiple: true,
      currentValue: ctx.query?.contractNo,
      changeMethod: ctx.changeContractMethod,
    },
    {
      prop: 'createMethod',
      name: '创建方式',
      type: 'select',
      options: ctx.dictListMap?.createMethod || [],
    },
    {
      name: '结算单编号',
      prop: 'settlementNo',
      type: 'input',
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalAmountStart', 'originalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },
  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    visible: true,
  },
  {
    field: 'businessCategory',
    title: '业务类别',
    visible: true,
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
    width: 220,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
    width: 220,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
    width: 220,
  },
  {
    field: 'accountPeriod',
    title: '应收账期',
    visible: true,
  },
  {
    field: 'expenseType',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'originalPrice',
    title: '结算单价（含税）',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unitName',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyCode',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'businessDocCode',
    title: '业务单据编码',
    visible: true,
  },
  // 未找到字段
  {
    field: 'goodsCategoryName',
    title: '货物品类',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '结算单编号',
    visible: true,
  },
  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
];

// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '新建',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  // {
  //   id: 2,
  //   label: '启用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 3,
  //   label: '禁用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'forbid',
  //   },
  // },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  {
    id: 5,
    label: '调整费用',
    type: '0',
    attributes: {
      buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'editExpense',
    },
  },
  {
    id: 6,
    label: '新增费用',
    type: '0',
    attributes: {
      buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'addExpense',
    },
  },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  {
    id: 8,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];

import BASE_API from '@/api/dataBase';
import API from '@/api/intermodality/order';
export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
      expenseTypeList: [],
      productList: [],
      serviceAllList: [],
      serviceList: [],
      query: {
        pageNum: 1,
        pageSize: 10,
        expenseNoLike: '',
        businessCompanyNo: '',
        businessDepartmentCode: '',
        processStatus: null,
        expenseTypeList: [],
        instructionNoLike: '',
        orderCodeLike: '',
        productType: '',
        serviceType: '',
        businessCategory: '05',
        accountPeriod: '',
        expenseGenerationDateStart: '',
        expenseGenerationDateEnd: '',
        abnormalExpenseFlag: '',
        confirmStatus: '',
        customerNo: '',
        contractNo: '',
        createMethod: '',
        originalAmountStart: '',
        originalAmountEnd: '',
        salesmanNo: '',
      },
      businessCompanyName: '',
      businessDepartmentName: '',
    };
  },
  methods: {
    // 获取公司
    async _getCompanyApi() {
      // console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        // console.log(data.data, '???=====》》');
        this.companyList = data.data?.personCompanyInfo;
        // console.log(this.companyList, 'companyList');
        // console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

        if (!this.userInfo.companyCode) {
          // console.log('非userInfo');
          const companyCode = data.data.personCompanyInfo
            ? data.data.personCompanyInfo[0].companyCode
            : null;
          const companyName = data.data.personCompanyInfo
            ? data.data.personCompanyInfo[0].companyName
            : null;
          this.query = {
            ...this.query,
            businessCompanyNo: companyCode,
            businessCompanyName: companyName,
          };
        } else {
          // console.log('userInfo');
          (this.query = {
            ...this.query,
            businessCompanyNo: this.userInfo.companyCode,
            // businessCompanyName: this.userInfo.companyName,
          }),
            (this.businessCompanyName = this.userInfo.companyName);
        }

        this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        console.log(data.data, '部门信息');
        this.departmentList = data.data?.personDepartmentInfo;
        if (isFirst) {
          this.query = {
            ...this.query,
            businessDepartmentCode: this.userInfo?.departmentCode,
            // businessDepartmentName: this.userInfo?.departmentName,
          };
          this.businessDepartmentName = this.userInfo?.departmentName;
          setTimeout(() => {
            this.getTableData();
          }, 10);
        }
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      // console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      // console.log(item, '切换公司item');
      this.query = {
        ...this.query,
        businessDepartmentCode: '',
        // businessDepartmentName: '',
        businessCompanyNo: val,
        // businessCompanyName: item.personCompanyName,
      };
      this.businessCompanyName = item.personCompanyName;
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      // console.log(val, '切换部门');
      // console.log(this.departmentList, 'this.departmentList');

      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.query = {
        ...this.query,
        businessDepartmentCode: val,
        // businessDepartmentName: item.personDepartmentName,
      };
      this.businessDepartmentName = item.personDepartmentName;
    },
    // 切换产品
    changeProductTypeHandler(val) {
      console.log('1111111', val);
      this.query.serviceType = '';
      this.query.expenseTypeList = [];
      this.expenseTypeList = [];
      this.serviceList = [];
      if (val == '0') {
        this.serviceList = this.serviceAllList.slice(0, 6);
      } else if (val == '1') {
        this.serviceList = this.serviceAllList.slice(6);
      }
    },
    // 切换合同编号
    changeContractMethod(val) {
      const rowData = val && Array.isArray(val) ? val[0] : val;
      console.log('切换合同编号', rowData);
      this.query = {
        ...this.query,
        contractNo: rowData.contractNo,
      };
    },
    // 切换客户名称
    customerNoMethod(val) {
      const rowData = val && Array.isArray(val) ? val[0] : val;
      console.log('rowData', rowData);
      this.query = {
        ...this.query,
        customerNo: rowData?.partnerCode,
        customerName: rowData?.partnerZhName,
      };
    },

    // 产品列表
    getProductList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-PRODUCT-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.productList = res.data.data || [];
            console.log(res.data.data, '产品');
          }
        });
    },
    // 服务列表
    getServiceList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-SERVICE-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.serviceAllList = res.data.data || [];
            console.log(res.data.data, '服务');
          }
        });
    },
  },

  mounted() {
    console.log(this.dictListMap?.createMethod, 'dictListMap?.createMethod');
    // this.getCompanyApi();
    this.$nextTick(() => {
      this._getCompanyApi();
      this.getProductList();
      this.getServiceList();
    });
    this.expenseTypeList = this.dictListMap?.expenseType;
  },
};
